export default {
	network_error: "网络错误",
	common: {
		loading: "加载中...",
		loadFailed: "加载失败",
	},
	error: {
		pageNotFound: "页面未找到",
		goBack: "返回首页",
	},
	tabbar: {
		pandapass: "Pandapass",
		ecny: "数币",
		center: "中心",
		shop: "商城",
		my: "我的",
	},
	refresh: {
		pulling: "下拉刷新...",
		loosing: "松开刷新...",
		loading: "加载中...",
	},
	home: {
		location: "选择城市",
		hangzhou: "杭州",
		search: "搜索",
		pandapass: "Pandapass",
		bannerDescription: "覆盖近30个景点，一次游览即可回本！",
		hotScenicSpot: "热门景点",
		liveStyle: "生活方式",
		filter: "筛选",
		picker_confirm: "确认",
		picker_cancel: "取消",
		all: "全部",
		restaurant: "餐饮",
		hotel: "酒店",
		entertainment: "娱乐",
		free: "Pandapass 免费",
		originalPrice: "原价：",
		noData: "暂无内容",
		useBtn: "使用",
		buyBtn: "购买",
	},
	packagePurchase: {
		title: "购买权益包",
		quantity: "数量",
		paymentMethod: "支付方式",
		total: "合计",
		payNow: "去支付",
		wechat: "微信",
		alipay: "支付宝",
		unionpay: "银联",
		creditcard: "信用卡",
		hpay: "市民云",
	},
	packageDetail: {
		title: "权益包详情",
		pandapass: "Pandapass",
		bannerDescription: "覆盖近30个景点，一次游览即可回本！",
		packageTitle: "Pandapass 权益包",
		packageDescription: "覆盖近30个景点，一次游览即可回本！",
		originalPrice: "原价",
		freeScenicSpot: "免费景点",
		liveStyle: "生活方式",
		pandapassFree: "Pandapass 免费",
		noData: "暂无内容",
		totalPrice: "总价",
		buyNow: "立即购买",
		purchased: "已购买",
		pleaseLogin: "请先登录",
		purchaseSuccess: "购买成功！",
	},
	search: {
		cancel: "取消",
		searchHistory: "搜索历史",
		topSearches: "热门搜索",
		searchResults: "搜索结果",
		noResults: "未找到相关结果",
		searching: "搜索中...",
	},
	ecny: {
		title: "数字人民币",
		digitalCurrency: "E-CNY",
		description: "体验中国官方数字货币的未来支付方式。",
		secure: "安全可靠",
		fast: "快速交易",
		convenient: "便捷支付",
		noCardMessage: "您还没有E-CNY卡片。在使用前需要先添加一张。",
		walletTitle: "E-CNY钱包",
		walletDescription: "它是由中国人民银行发行的法定数字货币，主要用于流通中的现金（M0）。由指定运营机构运营，面向公众开放兑换。货币以电子形式存在，其价值等同于人民币纸币和硬币。",
		addNow: "立即添加",
		recharge: "充值",
		activeWallet: "激活钱包",
		enterCard: "请输入您的卡号",
		confirm: "确认",
		errorMessage: "请输入16位卡号",
		checkingWallet: "检查钱包状态中...",
	},
	recharge: {
		title: "余额充值",
		rechargeAmount: "充值金额",
		otherAmount: "其他金额",
		otherAmountPlaceholder: "请输入充值金额",
		paymentMethod: "支付方式",
		rechargeNow: "立即充值",
		selectAmount: "请选择或输入充值金额",
		rechargeInProgress: "充值功能开发中...",
		cardStatus: "已激活",
	},
	shop: {
		title: "商城",
		buy: "购买",
		scenic: "景点",
		entertainment: "娱乐",
		food: "美食",
	},
	my: {
		order: {
			allOrders: "全部订单",
			Processing: "待支付",
			Completed: "已完成",
			afterSales: "售后",
		},
		address: "地址",
		ai: "Pandapass AI 助手",
		customerService: "Pandapass 客服",
		scanToAdd: "扫一扫上面的二维码图案，加我为朋友",
		register: "注册/登录",
		exit: "退出",
		confirmTitle: "温馨提示",
		confirm: "确定",
		cancel: "取消",
		confirmMessage: "确定要退出登录吗？",
		pleaseLogin: "请先登录",
	},
	shopCart: {
		title: "购物车",
		total: "总计",
		buy: "购买",
		delete: "删除",
		emptyCart: "您的购物车是空的",
		stockNotEnough: "库存不足",
		discontinued: "已下架",
	},
	order: {
		sendParcel: "寄送包裹",
		pickUp: "自提",
		chooseAnotherAddress: "选择其他收货地址",
		buy: "购买",
		orderNumber: "订单号",
		orderStatus: "订单状态",
		waitPayment: "待付款",
		paid: "已付款",
		shipped: "已发货",
		received: "已收货",
		completed: "已完成",
		cancelled: "已取消",
		timeout: "已超时",
		paymentTimeout: "支付超时",
		orderTotal: "订单总额",
		deliveryFee: "配送费",
		actualPayment: "实付金额",
		paymentMethod: "支付方式",
		deliveryMethod: "配送方式",
		recipientInfo: "收货信息",
		recipientName: "收货人",
		recipientPhone: "联系电话",
		recipientAddress: "收货地址",
		orderTime: "下单时间",
		paymentTime: "支付时间",
		deliveryTime: "发货时间",
		completeTime: "完成时间",
		orderRemark: "订单备注",
		itemCount: "件商品",
		moreItems: "等{count}件商品",
		cancelOrder: "取消订单",
		loading: "加载中...",
		noOrders: "暂无订单",
		goShopping: "去购物",
		confirmReceive: "确认收货",
		applyAfterSales: "申请售后",
		viewAfterSales: "查看售后",
		cancelAfterSales: "取消售后",
		deleteOrder: "删除订单",
		confirmDelete: "确认删除",
		confirmDeleteMessage: "确定要删除这个订单吗？",
		// 订单状态
		statusWaitPay: "待付款",
		statusWaitShipping: "待发货",
		statusWaitReceive: "待收货",
		statusCompleted: "已完成",
		statusAfterSale: "售后中",
		statusTimeout: "已超时",
		statusUnknown: "未知状态",
		statusAfterSaleReturn: "售后完成",
		statusAfterSaleCancel: "售后取消",
		// 提示信息
		getOrderListFailed: "获取订单列表失败",
		// 地址相关
		completeAddress: "请完善收件人信息",
		enterAddress: "未选择收货地址",
		completePickupAddress: "请选择自提点",
		noPickupPoints: "暂无可用的自提点",
		// 支付相关
		processing: "处理中",
		payProcessing: "支付处理中",
		paymentConfirm: "支付确认",
		paymentConfirmMessage: "请确认您已完成支付",
		confirm: "确认",
		cancel: "取消",
		getOrderDetailFailed: "获取订单详情失败",
		networkError: "网络错误，请稍后重试",
		operationSuccess: "操作成功",
		operationFailed: "操作失败",
		orderCancelSuccess: "订单取消成功",
		cancelOrderFailed: "取消订单失败",
		updateOrderStatusFailed: "更新订单状态失败",
		unpaidOrderCannotApplyAfterSales: "未支付订单不能申请售后",
		completedOrderCannotApplyAfterSales: "已完成订单不能申请售后",
		alreadyInAfterSales: "订单已在售后中",
		notInAfterSales: "订单不在售后中",
		// 确认对话框
		confirmCancel: "确认取消",
		confirmCancelMessage: "确定要取消这个订单吗？",
		confirmReceiveTitle: "确认收货",
		confirmReceiveMessage: "确定已收到商品吗？",
		confirmApplyAfterSalesMessage: "确定要申请售后吗？",
		confirmCancelAfterSalesMessage: "确定要取消售后吗？",
		// 订单详情页面
		copy: "复制",
		shippingInformation: "收货信息",
		receivingAddress: "收货地址",
		orderNumberCopied: "订单号已复制",
		copyFailed: "复制失败",
		orderIdRequired: "订单ID不能为空",
		loadFailed: "加载失败",
		orderDetails: "订单详情",
		remark: "备注",
		// 刷新相关
		refreshSuccess: "刷新成功",
		refreshFailed: "刷新失败",
		statusAfterSaleReject: "售后拒绝",
		iGotIt: "知道了",
		vipOrderPaymentProcessing: "订单处理中",
		vipOrderPaymentProcessingMessage: "当前订单未检测到支付状态（可能还在处理中），即将跳转到订单列表页面",
		// 支付相关错误提示
		getDefaultAddressFailed: "获取默认地址失败",
		getPickupPointsFailed: "获取自提地点失败",
		paymentParamError: "支付参数错误",
		paymentCallFailed: "支付调用失败，请重试",
		linkCopied: "链接已复制，请在浏览器中打开",
		copyFailed2: "复制失败，请手动复制链接",
		paymentProcessing: "支付处理中，请稍后确认",
		paymentFailed: "支付失败，请重试",
		paymentCancelled: "支付已取消",
		paymentStatusUnknown: "支付状态未知，请确认支付结果",
		// 支付对话框
		paymentTip: "支付提示",
		wechatPaymentTip: "检测到您在微信中，请复制链接到浏览器中打开完成支付",
		copyLink: "复制链接",
		jumpingToAlipay: "正在跳转支付宝...",
		// 默认值
		defaultPickupPoint: "自提点",
		userOrderRemark: "用户下单",
		// 错误信息相关
		need: "需要",
		pieces: "件",
		stockOnly: "库存仅",
		productDiscontinued: "商品已下架",
		productId: "商品ID",
		productNotExist: "商品不存在",
		paramError: "参数错误",
	},
	orderList: {
		orderTitle: "订单列表",
		all: "全部",
		Processing: "待付款",
		ToShipping: "待发货",
		Delivering: "待收货",
		Completed: "已完成",
		AfterSales: "售后",
		goPay: "去支付",
		afterSalesBtn: "申请售后",
	},
	address: {
		title: "地址",
		setAsDefault: "设为默认",
		defaultSet: "已设为默认地址",
		editInProgress: "编辑功能开发中...",
		deleteConfirmTitle: "确认删除",
		deleteConfirmMessage: "确定要删除这个地址吗？",
		deleteSuccess: "地址删除成功",
		addInProgress: "添加地址功能开发中...",
		consignee: "收件人",
		enterRecipientName: "请输入收件人姓名",
		phoneNumber: "手机号",
		enterPhoneNumber: "请输入手机号",
		address: "地址",
		place_name: "地点名称",
		enterPlaceName: "请输入地点名称",
		houseNumber: "门牌号",
		enterHouseNumber: "请输入门牌号",
		save: "保存",
		locating: "定位中...",
		pleaseCompleteForm: "请完善表单信息",
		saveSuccess: "保存成功",
		editShippingAddress: "编辑收货地址",
		addShippingAddress: "添加收货地址",
	},
	deliveryDetail: {
		title: "配送中",
		expectedArrival: "您的货物正在路上",
		actualPaymentAmount: "实付金额",
		orderNumber: "订单号",
		copy: "复制",
		deliveryMethod: "配送方式",
		delivery: "配送",
		orderTime: "下单时间",
		paymentTime: "支付时间",
		shippingInformation: "收货信息",
		receivingAddress: "收货地址",
		pickupPhone: "自提电话",
		pickupAddress: "自提地址",
		business_hours: "营业时间",
		deliveryTime: "发货时间",
		carrier: "承运机构",
		contractor_phone: "配送员电话",
		contractor: "配送员",
	},
	paymentResult: {
		home: "首页",
		checking: "正在查询订单状态...",
		success: "支付成功",
		failed: "支付失败",
		finshed: "交易完成",
		close: "关闭",
	},
	productDetail: {
		commodityInfo: "商品信息",
		forYou: "为您推荐",
		addToCart: "加入购物车",
		buy: "立即购买",
		quantity: "数量",
		addToCartSuccess: "已添加到购物车",
		buyInProgress: "购买功能开发中...",
		navigationInProgress: "跳转功能开发中...",
	},
	codeView: {
		notLoggedInMessage: "您尚未登录账户，因此无法显示您的二维码。",
		notBuyPackageMessage: "您尚未购买卡片。",
		goToLogin: "登录",
		goToBuy: "购买",
		loginInProgress: "跳转到登录页面...",
		goToUse: "可使用",
		expired: "已过期",
		qrcodeError: "请切换二维码或重新购买。",
	},
	detail: {
		title: "Pandapass 福利",
		freeBtn: "Pandapass 免费",
		originalPrice: "原价",
		useBtn: "使用",
		travelInfo: "旅游信息",
		scenicHours: "全年开放",
		foodHours: "营业时间",
		navigation: "导航",
		call: "电话",
		video: "视频",
		image: "图片",
		introduction: "介绍",
		selectMap: "选择地图",
		amap: "高德地图",
		google: "谷歌地图",
		apple: "苹果地图",
		tencent: "腾讯地图",
		baidu: "百度地图",
	},
	center: {
		title: "服务中心",
		subtitle: "一站式服务平台",
		quickActions: "快捷操作",
		scan: "扫码",
		pay: "支付",
		transfer: "转账",
		actionExecuting: "正在执行",
		feature1: {
			title: "智能推荐",
			description: "基于您的偏好推荐最佳服务",
		},
		feature2: {
			title: "快速响应",
			description: "毫秒级响应，极速体验",
		},
		feature3: {
			title: "安全保障",
			description: "多重加密，资金安全无忧",
		},
		feature4: {
			title: "贴心服务",
			description: "7×24小时专业客服支持",
		},
	},
	register: {
		title: "注册",
		phoneEmail: "邮箱",
		phoneEmailPlaceholder: "请输入邮箱地址",
		emailCode: "邮箱验证码",
		emailCodePlaceholder: "请输入验证码",
		getCode: "获取验证码",
		password: "密码",
		passwordPlaceholder: "请输入密码",
		confirmPassword: "确认密码",
		confirmPasswordPlaceholder: "请再次输入密码",
		register: "注册",
		haveAccount: "已有账号？",
		login: "登录",
		enterPhoneEmailFirst: "请先输入邮箱地址",
		codeSent: "验证码已发送",
		pleaseCompleteForm: "请完善表单信息",
		codeSendFailed: "验证码发送失败",
		registering: "注册中...",
		registerSuccess: "注册成功",
	},
	login: {
		title: "登录",
		phoneEmail: "邮箱",
		phoneEmailPlaceholder: "请输入邮箱地址",
		password: "密码",
		passwordPlaceholder: "请输入密码",
		login: "登录",
		noAccount: "没有账号？",
		register: "注册",
		pleaseCompleteForm: "请完善表单信息",
		loginInProgress: "登录中...",
	},
	api: {
		success: "操作成功",
		paramError: "参数错误",
		userExist: "用户已存在",
		codeError: "验证码错误",
		registerSuccess: "注册成功",
		codeUsed: "验证码已失效",
		loginSuccess: "登录成功",
		userNotExist: "用户不存在",
		passwordError: "密码错误",
		rateLimitExceeded: "请求过于频繁，请稍后再试",
		addToCartSuccess: "已添加到购物车",
		productNotExist: "商品已下架",
		stockNotEnough: "库存不足",
		vipOrderCreateSuccess: "订单创建成功",
		vipOrderCreateFailed: "订单创建失败",
		vipOrderNotExist: "订单不存在",
		vipOrderNotPayment: "未支付",
		vipOrderPaymentSuccess: "支付成功",
		vipOrderPaymentFailed: "支付失败",
		vipOrderPaymentTimeout: "支付超时",
		vipOrderListFailed: "获取订单列表失败",
		vipOrderStatusUpdateFailed: "订单状态更新失败",
		vipOrderStatusUpdateSuccess: "订单状态更新成功",
		vipOrderCancelFailed: "订单取消失败",
		vipOrderCancelSuccess: "订单取消成功",
		paidOrderCannotCancel: "已发货订单不能取消",
		itemsRequired: "该商品已下单或不存在",
		invalidDeliveryType: "配送方式无效",
		invalidPaymentMethod: "无效的支付方式",
		deliveryAddressRequired: "配送订单需要选择配送地址",
		pickupAddressRequired: "自提订单需要选择自提地址",
		ecnyBindSuccess: "卡片绑定成功",
		ecnyBindFailed: "卡片绑定失败",
		ecnyInvalidCardNumber: "卡号格式不正确，请输入16位数字",
		ecnyCardNotFound: "卡号不存在或已被绑定",
		ecnyEmailNotMatch: "您的邮箱与卡号不匹配，请联系客服",
		ecnyUserAlreadyBound: "您已绑定其他卡片",
		ecnyCheckFailed: "检查钱包状态失败",
		ecnyWalletFound: "钱包已绑定",
		ecnyWalletNotFound: "钱包未绑定",
		applyAfterSalesSuccess: "申请售后成功",
		applyAfterSalesFailed: "申请售后失败",
		cancelAfterSalesSuccess: "取消售后成功",
		cancelAfterSalesFailed: "取消售后失败",
		packageCountExceeded: "Pandapass特权套餐仅限5次购买",
		qrcodeNotFound: "二维码不存在",
		qrcodeExpired: "二维码已过期",
		qrcodeAlreadyUsed: "二维码已使用",
		qrcodeUsedSuccess: "二维码使用成功",
		qrcodeUpdateFailed: "二维码更新失败",
		iGotIt: "知道了",
		vipOrderDeleteSuccess: "订单删除成功",
		vipOrderDeleteFailed: "订单删除失败",
		orderCannotDelete: "订单不可删除",
		loginExpired: "登录过期，请先登录！",
	},
};
